const asArray = value => (Array.isArray(value) ? value : []);

export function normalizeMissingDependency(dependency = {}) {
  if (typeof dependency === 'string') {
    const assignmentMatch = dependency.match(/^(.*):(\d{4})$/);
    if (assignmentMatch) {
      return normalizeMissingDependency({
        dependency_type: 'OFFICE_ELECTRICITY_ASSIGNMENT',
        location_code: assignmentMatch[1],
        fiscal_year: assignmentMatch[2],
      });
    }
    return normalizeMissingDependency({
      dependency_type: 'EMISSION_FACTOR',
      item_key: dependency,
    });
  }
  return {
    type: dependency.type || dependency.dependency_type || dependency.reason_code || 'UNKNOWN',
    officeCode: dependency.office_code || dependency.location_code || null,
    officeName: dependency.office_name || dependency.location_name || null,
    fiscalYear: Number(dependency.fiscal_year) || null,
    supplierRegistrationNo: dependency.supplier_registration_no
      || dependency.registration_no
      || null,
    supplierName: dependency.supplier_name_ja || dependency.supplier_name || null,
    applicationCode: dependency.application_code || null,
    itemKey: dependency.item_key || dependency.ef_item_key || null,
  };
}

const dependencyValues = source => [
  ...asArray(source?.missing_dependencies),
  ...asArray(source?.dependencies),
  ...asArray(source?.missing_assignments),
  ...asArray(source?.missing_item_keys),
  ...asArray(source?.params?.missing_dependencies),
  ...asArray(source?.params?.missing_assignments),
  ...asArray(source?.params?.missing_item_keys),
  ...asArray(source?.error_summary?.params?.missing_dependencies),
  ...asArray(source?.error_summary?.params?.missing_assignments),
  ...asArray(source?.error_summary?.params?.missing_item_keys),
];

export function normalizeMissingDependencies(...sources) {
  const dependencies = sources.flatMap(source => (
    Array.isArray(source) ? source : dependencyValues(source)
  ));
  const unique = new Map(dependencies.map(dependency => {
    const normalized = normalizeMissingDependency(dependency);
    return [JSON.stringify(normalized), normalized];
  }));
  return [...unique.values()];
}
